if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        
        // Bind event listeners
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      connectedCallback() {
        // Listen for product added event (this theme uses 'product:added')
        this.productAddedHandler = this.onProductAdded.bind(this);
        document.addEventListener('product:added', this.productAddedHandler);
      }

      disconnectedCallback() {
        if (this.productAddedHandler) {
          document.removeEventListener('product:added', this.productAddedHandler);
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.innerText = 'Recipient form expanded';
          }
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.innerText = 'Recipient form collapsed';
          }
        }
        
        // Trigger layout recalculation for absolute positioned Product__InfoWrapper
        this.triggerLayoutUpdate();
      }
      
      triggerLayoutUpdate() {
        // Wait for CSS transition to complete
        setTimeout(() => {
          const productInfo = document.querySelector('.Product__Info');
          const infoWrapper = document.querySelector('.Product__InfoWrapper');
          const productAside = document.querySelector('.Product__Aside');
          const productWrapper = document.querySelector('.Product__Wrapper');
          
          if (!productInfo || window.innerWidth < 1000) {
            return; // Not in desktop layout
          }
          
          // Use the same calculation logic as the theme
          const productInfoStyles = window.getComputedStyle(productInfo);
          const productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom);
          
          if (productAside && infoWrapper) {
            // With aside (tabs) - matches theme's calculateMinHeight
            productAside.style.minHeight = (productInfo.scrollHeight - productInfoPadding) + 'px';
            infoWrapper.style.maxHeight = (productAside.offsetTop + productInfo.scrollHeight - productInfoPadding) + 'px';
          } else if (productWrapper) {
            // Without aside - matches theme's calculateMinHeight
            productWrapper.style.minHeight = (productInfo.scrollHeight - parseInt(productInfoStyles.paddingTop)) + 'px';
          }
        }, 450); // Slightly longer than CSS transition to ensure complete expansion
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        if (!this.errorMessageWrapper) return;
        
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          if (this.errorMessage) {
            this.errorMessage.innerText = this.defaultErrorHeader;
          }
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        if (this.errorMessage) {
          this.errorMessage.innerText = body;
        }
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        if (this.errorMessageWrapper) {
          this.errorMessageWrapper.hidden = true;
        }

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          if (inputElement) {
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
          }
        });
      }

      onProductAdded(event) {
        // Reset form after product is successfully added to cart
        this.resetRecipientForm();
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
          this.disableInputFields();
        }
      }
    }
  );
}
